import React from 'react';
import { PortableText } from '@portabletext/react';
import * as styles from './richText.module.scss';
import { SanityBlock } from '../../../../graphql-types';

interface IRichTextProps {
  value: Array<SanityBlock | null>;
  noMarginBottom?: boolean;
  className?: string;
}

const MarkColorResolver = (props) => (
  <span style={{ color: `${props?.value?.hex}` }}>{props?.children}</span>
);

const LinkResolver = (props) => (
  <a href={props?.value?.href} target={props?.value?.target}>
    {props?.children}
  </a>
);

export const RichText = ({ value, noMarginBottom, className }: IRichTextProps) => (
  <div
    className={`${styles.wrapper} ${noMarginBottom ? styles.noMarginBottom : ''} ${
      className ?? ''
    }`}
  >
    <PortableText
      value={value as any}
      components={{
        list: {
          bullet: ({ children }) => <ul>{children}</ul>,
          number: ({ children }) => <ol>{children}</ol>,
        },
        marks: {
          color: MarkColorResolver,
          link: LinkResolver,
        },
      }}
    />
  </div>
);
